import React from "react";

const Home = () => {
  return (
    <div>
      <h1>Hello World im react!</h1>
    </div>
  );
};

export default Home;
